const CHANGE_PASSWORD_MESSAGES = {
  CHANGE_PASSWORD_SUCCESS: 'Password changed successfully',
  CHANGE_PASSWORD_FAILURE:
    'Oops!!! Something, Somewhere, Shomehow went wrong...',
}

export default CHANGE_PASSWORD_MESSAGES
